import { T } from '../textes-interface.js';

/**
 * Bascule « Texte agrandi ».
 *
 * Contrainte de classe : les tablettes sont partagées et lues à plusieurs, parfois
 * de loin. Le bouton agrandit tout le texte de la page sans changer la mise en page.
 */
export function BoutonTexteAgrandi({
  actif,
  onBasculer,
}: {
  actif: boolean;
  onBasculer: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onBasculer}
      aria-pressed={actif}
      className="flex min-h-touch items-center gap-2 rounded-xl bg-white px-4 font-semibold text-slate-700 shadow-sm hover:bg-slate-50"
    >
      <span aria-hidden="true">🔍</span>
      <span>{actif ? T.accessibilite.texteNormal : T.accessibilite.texteAgrandi}</span>
    </button>
  );
}
